// extracted by mini-css-extract-plugin
module.exports = {"cimemaWrapper":"cimemaWrapper___2ORDJ","navBar":"navBar___315d7","bg":"bg___19auB","dfMenuWrapper":"dfMenuWrapper___2eigM"};